import { DefaultSEO } from '@/src/lib/seo';
import type { NextPageWithAuth } from '@/src/types/page';
import { NextSeo } from 'next-seo';
import Link from 'next/link';
import FabricError from '../src/templates/FabricError';
import { appRoutes } from '@fabric-app/business/app/routing/routes.config';

export async function getStaticProps() {
  return {
    props: {},
    revalidate: false,
  };
}

const Custom404: NextPageWithAuth = () => {
  return (
    <>
      <NextSeo {...DefaultSEO} />
      <FabricError>
        <h1>404</h1>
        <h4>There’s nothing here!</h4>
        <p>How did you even get here?</p>
        <Link href={appRoutes.home}>Let’s get you back to your dashboard</Link>
      </FabricError>
    </>
  );
};

Custom404.authRequirements = { requiresAuth: false };

export default Custom404;
